import type { Resource } from '../../';
export const checkout_shipping_errors_zipCode: Resource = {"default":"Invalid zip code."};
